import { Injectable } from '@angular/core';
import { ClientProfessional } from '../../domain/models/client-professional.model';
import { ClientProfessionalDto } from '../dtos/client-professional.dto';

@Injectable()
export class ClientProfessionalMapper {
  public toClientProfessional(dto: ClientProfessionalDto): ClientProfessional {
    const fullName = [dto.FirstName, dto.LastName].filter((part) => !!part?.trim()).join(' ');
    return {
      id: dto.ExternalId,
      name: dto.DisplayName?.trim() || fullName || dto.Email?.trim() || dto.ExternalId,
      email: dto.Email?.trim() || null,
    };
  }
}
